"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = require("react");
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var Text_1 = __importDefault(require("shared/components/Text"));
var TextInput_1 = __importDefault(require("../../TextInput"));
var context_1 = require("../context");
var UnitsTextfield = function (_a) {
    var _b;
    var item = _a.item;
    var _c = (0, react_1.useContext)(context_1.AnalyserFormContext), updateRow = _c.updateRow, srvPricePlans = _c.srvPricePlans;
    // const setField = <F extends keyof PricingPlanRow>(field: F, value: PricingPlanRow[F]) => updateRow({ ...item, [field]: value });
    if (!srvPricePlans) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    var tier = (0, end2end_1.getRowFamilyAndTier)(srvPricePlans)(item).tier;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (tier === null || tier === void 0 ? void 0 : tier.pricingModel) !== 'flat_fee'
            ? ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "inline-flex", alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(TextInput_1.default, { isNumber: true, align: "left", alignItems: "flex-start", onChange: function (e) { return updateRow(item.id, __assign(__assign({}, item), { units: e.target.value ? Number(e.target.value.replace(/[^\d.]/g, '')) : undefined })); }, value: (_b = item.units) === null || _b === void 0 ? void 0 : _b.toLocaleString(), width: 85 }), (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", component: "small", width: 150 }, { children: tier === null || tier === void 0 ? void 0 : tier.unitsName }))] })))
            : (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: "caption", component: "small" }, { children: tier === null || tier === void 0 ? void 0 : tier.description })) }));
};
exports.default = UnitsTextfield;
